import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import { getTopicPath } from '../lib/contentUtils';
import { pickDailyClarityTopics } from '../lib/clarityTopicLinks';

export function ClarityTopicNav() {
  const { data, loading } = useContent();
  const links = useMemo(() => (data ? pickDailyClarityTopics(data, 2) : []), [data]);

  if (loading || !data || links.length === 0) {
    return null;
  }

  return (
    <aside className="related-topics clarity-related-topics" aria-label="Related documented topics">
      <h3>Explore documented topics</h3>
      <p className="related-hint">
        Two entries from civil rights, healthcare, accountability, and abuse-of-power—updated daily
      </p>
      <nav className="topic-nav clarity-topic-nav" aria-label="Related topic entries">
        {links.map((link) => (
          <Link key={link.item.id} to={getTopicPath(data, link.item)} className="topic-nav-link">
            <span className="topic-nav-dir">Related topic</span>
            <span className="topic-nav-title">{link.item.title}</span>
            <span className="topic-nav-pos">{link.issueTitle}</span>
          </Link>
        ))}
        {links.length === 1 && <div className="topic-nav-placeholder" />}
      </nav>
    </aside>
  );
}
